import AvailableGames from './AvailableGames';
import Preview from './Preview';
import Prizes from './Prizes';
import Offers from './Offers';
import Promo from './Promo';
import VideoWinners from './VideoWinners';
import PrizeSlider from './PrizeSlider';

export { AvailableGames, Preview, Prizes, Offers, Promo, VideoWinners, PrizeSlider };
